export default "__VITE_ASSET__ByM$XLBd__"